/* eslint-disable prefer-promise-reject-errors */
import Axios from "axios";
import { camelizeKeys } from "humps";
import { getServersideUrl } from "main/utils/hostUtil";

export function createWrapper({
  isMultipart = false,
  isServerSide = false,
  withCredentials = true,
  locale = null,
} = {}): any {
  const config: any = {
    headers: {
      Accept: "application/json",
      "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
      // Accept: "application/json",
      // "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
      // "X-API-KEY": process.env.X_API_KEY,
      // "Access-Control-Allow-Origin": "*",
      // 'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      // "X-Requested-With": "XMLHttpRequest", // TODO
      // 'X-CSRF-Token': isCsrf ? getCsrfToken() : "",
    },
    baseURL: isServerSide ? getServersideUrl(locale) : null,
    timeout: 600000,
    withCredentials: withCredentials,
  };

  const wrapper: any = Axios.create(config);

  wrapper.interceptors.response.use(
    (response: any): any => ({
      ...response,
      data: camelizeKeys(response.data),
    }),
    (error: any): any => {
      if (error.code === "ECONNABORTED") {
        return Promise.reject({
          ...error,
          response: {
            data: {
              errors: {
                base: ["timeout"],
              },
            },
          },
        });
      } else if (!error.response || !error.response.data) {
        return Promise.reject({
          ...error,
          response: {
            data: {
              errors: {
                base: ["error"],
              },
            },
          },
        });
      }
      // error全てをcamelizeKeysするとMaximum call stack size exceeded humpsが発生するため
      // 必要なデータだけ抜粋する
      const errorData = {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
      };
      return Promise.reject(camelizeKeys(errorData));
    },
  );
  return wrapper;
}
